// extracted by mini-css-extract-plugin
export default {"maskStyledInput":"MaskStyledInput_maskStyledInput__1xomN"};